export interface Transactions {
  language: string;

  [key: string]: string;
}

type Props = (
  translations: Transactions[],
  title: string,
  language: string,
  key?: string,
  fallbackLanguage?: string,
) => string | null;

/**
 * Получает заголовок на нужном языке из массива переводов
 * @param translations - Массив объектов переводов
 * @param title - Default title if translation not found
 * @param language - Текущий язык пользователя
 * @param key - Ключ, по которому нужно получить перевод (по умолчанию "title")
 * @param fallbackLanguage - Резервный язык, если перевод на текущем языке не найден (по умолчанию "en")
 * @returns Translated title or title if translation not found
 */
export const getTitleByLanguage: Props = (
  translations = [],
  title,
  language,
  key = "title",
  fallbackLanguage = "en",
) => {
  // Try to find translation for the current locale that is **not** an empty string
  const currentLangTranslation = translations?.find(
    (item) => item.language === language && item[key]?.trim() !== "",
  );

  if (currentLangTranslation) {
    return currentLangTranslation[key];
  }

  // Fallback to the explicit fallback language (commonly "ru") when provided
  if (fallbackLanguage && fallbackLanguage !== language) {
    const fallbackTranslation = translations.find(
      (item) => item.language === fallbackLanguage && item[key]?.trim() !== "",
    );

    if (fallbackTranslation) {
      return fallbackTranslation[key];
    }
  }

  // As a last resort, use the first non-empty translation regardless of language
  const firstNonEmpty = translations.find((item) => item[key]?.trim() !== "");
  if (firstNonEmpty) {
    return firstNonEmpty[key];
  }

  return title;
};
